// extracted by mini-css-extract-plugin
module.exports = {"skeletonDraggableUploadFileStub":"DocumentsUploadConfiguration_skeletonDraggableUploadFileStub__3DMMw"};